import React, { useState } from "react";

import styled from "styled-components";
import Img from "../../assets/category.png";
const Container = styled.div`
  width: 19%;
  height: auto;
  background: #fafafa;
  margin: 0 1% 0 0;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background: #e9ebec;
  }
  @media (max-width: 768px) {
    width: 48%;
    margin: 0 1% 1% 0;
  }
`;
const ContainerActive = styled.div`
  width: 19%;
  height: auto;
  background: #e9ebec;
  margin: 0 1% 0 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 5px;
  cursor: pointer;
`;
const CatImg = styled.img`
  width: 50px;
  height: 50px;
`;
const Title = styled.p`
  margin: 0;
  padding: 5px;
`;
function CatView(props) {
  return (
    <Container
      onClick={() => props.catChangeHandler(props.cat._id, props.index)}
    >
      <CatImg src={props.icon} alt="img" />
      <Title>{props.cat.name}</Title>
    </Container>
  );
}

export default CatView;
